import { vslApi } from '@/api';

export default Object.freeze({
  fetchMyBillLadingList(params) {
    return vslApi.get(`/v1/public-ebookings/my-bill-ladings`, {
      params,
    });
  },
});
